import { makeObservable, observable, action, runInAction } from "mobx";
import dayjs from "dayjs";

import { LabelValue } from "../../../models/Dashboard/Analytics";
import FinanceAnalyticsDashboardAPI from "../api/FinanceAnalyticsDashboardAPI";
import { FinanceAnalyticsAPIFilters } from "../../../models/Dashboard/FinanceDashboard/FinanceAnalyticsFilters";

export class FinanceAnalyticsStore {
  analyticsAPI: FinanceAnalyticsDashboardAPI;
  tats: LabelValue[];

  constructor() {
    this.analyticsAPI = new FinanceAnalyticsDashboardAPI();
    this.tats = [];

    makeObservable(this, {
      tats: observable,
      getAllAnalyticsData: action,
      _getTATs: action,
    });
  }

  getAllAnalyticsData = async (filters: FinanceAnalyticsAPIFilters) => {
    try {
      filters.start_date = dayjs(filters.start_date, "YYYY-MM-DD").format(
        "YYYY-MM-DD HH:mm:ss"
      );

      filters.end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .subtract(1, "second")
        .format("YYYY-MM-DD HH:mm:ss");

      await Promise.all([this._getTATs(filters)]);
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  _getTATs = async (filters: FinanceAnalyticsAPIFilters) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "/tats",
        filters
      )) as LabelValue[];
      this.tats = data;
    } catch (error) {
      throw error;
    }
  };
}
